import { MiscScreen } from '@betty/navigation';

function TermsAndConditionsScreen() {
  return <MiscScreen path="/terms" />;
}

export default TermsAndConditionsScreen;
